import {useDroppable} from '@dnd-kit/core';

export default function Droppable({id, children, data, disabled}){

  const {isOver, setNodeRef} = useDroppable({id: id, data: data, disabled: disabled});

  const style = {
    height: 10,
    margin: '0px 0px',
    backgroundColor: 'transparent',
  };

  const overStyle = {
    height: 50,
    backgroundColor: 'rgba(0,0,0,0.05)',
    margin: '5px 0px',
    borderRadius: '5px',
    transition: 'height 0.3s'
  };
  
  return <div ref={setNodeRef} style={(!disabled && isOver) ? overStyle : style}>
    {children}
  </div>

}